// Blog "Load more": fetches the next archive page and appends its cards.
// The button is a regular link to /page/N/, so it still works without JS.
export const loadMorePosts = () => {
  const button = document.querySelector("[data-load-more]");
  const grid = document.querySelector("[data-posts-grid]");
  if (!button || !grid) return;

  button.addEventListener("click", async (event) => {
    event.preventDefault();
    if (button.getAttribute("aria-busy") === "true") return;

    // aria-busy shows the spinner and disables the button (see index.php)
    button.setAttribute("aria-busy", "true");

    try {
      const response = await fetch(button.href);
      if (!response.ok) throw new Error(response.statusText);

      const page = new DOMParser().parseFromString(await response.text(), "text/html");
      const cards = page.querySelectorAll("[data-posts-grid] [data-post-card]");
      const nextButton = page.querySelector("[data-load-more]");

      grid.append(...cards);
      cards[0]?.querySelector("h3 a")?.focus();

      if (nextButton) {
        button.href = nextButton.href;
      } else {
        button.parentElement.remove();
      }
    } catch (error) {
      window.location.href = button.href;
    } finally {
      button.removeAttribute("aria-busy");
    }
  });
};
